import React from 'react';
import { removeHTML } from '../../framework/utilities';

export default function RecipeCards({ recipes, ads }) {
  let ad_index = 0;
  return recipes.map(
    (recipe, i) =>
      recipe.recipes && (
        <div key={i} data-key={i}>
          <div className="callout callout__container u--margin-bottom-30">
            <div className="callout__tab">{recipe.mag} Recipe Contest</div>
            <div className="grid callout__grid grid--no-gutter callout--recipe callout--has-tab">
              <div className="grid__col-xs-8">
                <aside className="grid callout__box callout">
                  <div className="callout__body ">
                    <div className="section__header">
                      <a href={recipe.url}>
                        <h4
                          className="section__header-text"
                          dangerouslySetInnerHTML={{ __html: recipe.title }}
                        />
                      </a>
                    </div>
                    <div className="callout__text">
                      {recipe.recipes.winner && <div className="kicker">Winning Recipe</div>}
                      {recipe.recipes.winner && recipe.recipes.winner.map((winningRecipe) => (
                        <div
                          key={winningRecipe.id}
                          className="callout__winner-box grid grid--gutter"
                        >
                          {winningRecipe.img && (
                            <div className="grid__col-md-4">
                              <div className="callout__winner-image">
                                <a
                                  href={winningRecipe.url}
                                  className="u--border-none"
                                >
                                  <img
                                    src={winningRecipe.img}
                                    alt={removeHTML(recipe.title)}
                                  />
                                </a>
                              </div>
                            </div>
                          )}
                          <div
                            className={
                              winningRecipe.img
                                ? 'grid__col-md-8'
                                : 'grid__col-xs-12'
                            }
                          >
                            <div className="callout__winner">
                              <div className="callout__winner-title grid">
                                <div className="callout__winner-icon grid__col-xs-12 grid__col-sm-2">
                                  <i className="icon-award"></i>
                                </div>
                                <div className="grid__col-xs-12 grid__col-sm-10">
                                  <a
                                    href={winningRecipe.url}
                                    dangerouslySetInnerHTML={{
                                      __html: winningRecipe.title
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="callout__winner-desc">
                                <p>
                                  {winningRecipe.desc.replace(
                                    /<\/?[^>]+(>|$)/g,
                                    ''
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      {recipe.recipes.runner_up && (
                        <div className="callout__runners">
                          <div className="kicker">Runners-Up</div>
                          {recipe.recipes.runner_up.map((linkedRecipe) => (
                            <div key={linkedRecipe.id} className="grid">
                              <div className="callout__runners-icon grid__col-xs-1">
                                <p>
                                  <i className="icon-spoon-and-fork"></i>
                                </p>
                              </div>
                              <div className="callout__runners-title grid__col-xs-11">
                                <p>
                                  <a
                                    href={linkedRecipe.url}
                                    dangerouslySetInnerHTML={{
                                      __html: linkedRecipe.title
                                    }}
                                  />
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                      {recipe.recipes.food_editor && (
                        <div className="callout__runners">
                          <div className="kicker">Food Editor’s Recipe</div>
                          {recipe.recipes.food_editor.map((linkedRecipe) => (
                            <div key={linkedRecipe.id} className="grid">
                              <div className="callout__runners-icon grid__col-xs-1">
                                <p>
                                  <i className="icon-spoon-and-fork"></i>
                                </p>
                              </div>
                              <div className="callout__runners-title grid__col-xs-11">
                                <p>
                                  <a
                                    href={linkedRecipe.url}
                                    dangerouslySetInnerHTML={{
                                      __html: linkedRecipe.title
                                    }}
                                  />
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
          {recipes.length !== i + 1 &&
          (i + 1) % 3 == 0 &&
          ads[ad_index] !== undefined ? (
            <div
              id={`gpt-ad-slot-square-${(i + 1) / 3}`}
              className="ad__container"
            ></div>
          ) : (
            ''
          )}
        </div>
      )
  );
}
